var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsCriticalAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.333 3.159a.725.725 0 0 1 .645-.393h14.088c.273 0 .523.153.647.397l2.709 5.355a.725.725 0 0 1-.093.795l-9.847 11.665a.725.725 0 0 1-1.11-.004L1.667 9.31a.725.725 0 0 1-.088-.795L4.333 3.16ZM5.42 4.215 3.412 8.12h4.22L9.58 4.215H5.42Zm5.78 0L9.25 8.12h5.25l-1.785-3.906H11.2Zm3.108 0 1.786 3.906h4.503L18.62 4.215h-4.313Zm5.907 5.355h-7.562v8.959l7.562-8.959Zm-9.011 8.937V9.57H3.77l7.434 8.937Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsCriticalAsset);
export default __webpack_public_path__ + "static/media/sidebar-icons-critical-asset.c3a6aad7dec66b9f18e44f1f0504ea21.svg";
export { ForwardRef as ReactComponent };